'use client'

import { motion } from 'framer-motion'

import ViverseSkeleton from '@/components/ViverseSkeleton'
import { mapTagsToGenres } from '@/constants/genre'
import { useGenreContext } from '@/context/GenreContext'
import { useWorldSearchContext } from '@/context/WorldSearchContext'
import { Link } from '@/i18n/navigation'

const GENRE_SKELETON_COUNT = 30

function AllGenresSkeleton() {
  return Array.from({ length: GENRE_SKELETON_COUNT }, (_, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0.5, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.01, duration: 0.1 }}
    >
      <ViverseSkeleton className="aspect-108/133 w-full rounded-xl md:w-[108px] lg:aspect-180/140 lg:w-[180px]" />
    </motion.div>
  ))
}

export default function AllGenres() {
  const { tags } = useGenreContext()
  const { mobileNavHeight } = useWorldSearchContext()

  if (tags.length === 0) {
    return <AllGenresSkeleton />
  }

  const genres = mapTagsToGenres(tags)

  return genres?.map((genre, index, array) => (
    <Link
      key={index}
      href={`/genre/${genre.name}`}
      style={{
        marginBottom: index === array.length - 1 ? mobileNavHeight : 0,
      }}
    >
      <div className="group relative aspect-108/133 w-full overflow-hidden rounded-xl transition-all duration-300 hover:shadow-2xl md:w-[108px] lg:aspect-[180/140] lg:w-[180px]">
        {/* Primary Background */}
        <div
          className="absolute inset-0 opacity-55"
          style={{ background: genre.primaryGradient }}
        />

        {/* Overlay Background */}
        <div
          className="absolute inset-0 opacity-20"
          style={{ background: genre.overlayGradient }}
        />

        {/* Content */}
        <div className="z-interactive relative flex h-full flex-col items-start gap-1 px-4 py-2">
          <h3 className="header-5 text-[16px] text-white drop-shadow-lg lg:text-[20px]">
            {genre.title}
          </h3>
        </div>

        {/* Icon */}
        <div className="absolute right-[-10%] bottom-[-30%] opacity-100">
          <genre.Icon className="size-[126px] transition-all group-hover:scale-110 group-hover:opacity-100" />
        </div>
      </div>
    </Link>
  ))
}
